import React, { useRef } from 'react';
import { Card, Container, Col, Button, Form } from "react-bootstrap";

/**
 * Contactdistributor Component
 * Sends form data directly to WhatsApp using the Click-to-Chat API.
 */
export const Contactform = () => {
    const formRef = useRef();

    const handleWhatsAppSubmit = (e) => {
        e.preventDefault();

        // 1. Extract values from the form using the ref
        const formData = new FormData(formRef.current);
        const data = {
            name: formData.get('from_name'),
            mobile: formData.get('from_mobile'),
            city: formData.get('from_city'),
       
            queries: formData.get('from_queries')
        };

        // 2. Define your WhatsApp Number (Include Country Code, No '+' or '-')
        // Example: 91 for India + 6292007000
        const myPhoneNumber = "916292007000";

        // 3. Construct the message with Line Breaks (%0a) and Bold Text (*)
        const message = `*ABP SEEDS*%0a` +
            `--------------------------%0a` +
            `*Name:* ${data.name}%0a` +
            `*Mobile:* ${data.mobile}%0a` +
            `*City:* ${data.city}%0a` +
          
            `*Message:* ${data.queries}`;

        // 4. Generate the URL and open in a new tab
        const whatsappUrl = `https://wa.me/${myPhoneNumber}?text=${message}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className='album py-1 bg-light'>
            <Container>
              
                    <Col md={12}>
                        <Card className="shadow-sm border-0">
                            <Card.Body className="p-4">
                                <div className="text-center mb-4">
                                    <h3 className='fw-bold' style={{ color: '#056839' }}>ABP Seeds </h3>
                                    <p className="text-muted small">Best Premium Seeds in Kolkata – High Germination & Quality Assured</p>
                                </div>

                                <Form ref={formRef} onSubmit={handleWhatsAppSubmit}>
                                    {/* Name Field */}
                                    <Form.Group className="mb-3">
                                        <Form.Control
                                            type="text"
                                            name="from_name"
                                            placeholder="Full Name"
                                            required
                                        />
                                    </Form.Group>

                                    {/* Mobile Field */}
                                    <Form.Group className="mb-3">
                                        <Form.Control
                                            type="tel"
                                            name="from_mobile"
                                            placeholder="Mobile Number"
                                            required
                                        />
                                    </Form.Group>

                                    {/* City Field */}
                                    <Form.Group className="mb-3">
                                        <Form.Control
                                            type="text"
                                            name="from_city"
                                            placeholder="City"
                                            required
                                        />
                                    </Form.Group>

                                    {/* Queries Field */}
                                    <Form.Group className="mb-3">
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="from_queries"
                                            placeholder="Enter your queries..."
                                            required
                                        />
                                    </Form.Group>

                                    <div className="d-grid gap-2">
                                        <Button variant="success" type="submit" >
                                            Send to WhatsApp
                                        </Button>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
               
            </Container>
        </div>
    );
};